import React  from 'react';
import { Link } from 'react-router-dom'; 
 
import axios from 'axios'; 
import ProductsSlider from './ProductsSlider';
import MD5 from 'crypto-js/md5';
import { SharedContext } from '../pages/createContext';
import {api_base_url, base_url} from '../common/Constants'; 
import Modal from './Modal';

class ProductsContent extends React.Component{
    static contextType = SharedContext;
   
    constructor(props){
        super(props); 

        this.state = {
            product : [],
            loading : 1,
            qty:1,
            size:1,
            sizes:[],
            size_list:[],
            success_cart : 0,
            price:0, 
            remarks:'',
            discount:0 ,
            showModal: false
        }
        

    }

    openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

    componentDidMount()
    {
        const { sharedState, setSharedState } = this.context;
        var data = { slug : this.props.slug}
        axios.post(api_base_url+"products", data).then(response=>{
            this.setState({product:response.data}); 
            this.setState({price:response.data.price}); 

            var datas = { product_id: response.data.id}
             axios.post(api_base_url+"sizes", datas).then(response=>{
                this.setState({sizes:response.data.sizes}); 
                this.setState({size_list:response.data.sizes_list});  
                this.setState({loading:0});   
 
            }); 

         
           
        });

        
        const order_session_id =  localStorage.getItem('order_session_id');
        var datacart = { order_session_id : order_session_id}
        axios.post(api_base_url+"cart", datacart).then(response=>{ 
            this.setState({cartcount:response.data.cart.length});  
            setSharedState(response.data.cart.length);
        });
        
    }

    addToCart=()=>{
        const { sharedState, setSharedState } = this.context;
        var order_session_id =  localStorage.getItem('order_session_id');
        if(order_session_id === "" || order_session_id === null || order_session_id === undefined)
        {
            const currentTime = new Date().getTime();
            order_session_id = MD5(currentTime.toString()).toString();
            localStorage.setItem('order_session_id',order_session_id) ;
        }

        var data = { qty : this.state.qty, price : this.state.price, product_id : this.state.product.id, order_session_id : order_session_id, size:this.state.size, remarks:this.state.remarks}
        axios.post(api_base_url+"cart/add", data).then(response=>{
            this.setState({success_cart:1});
            setSharedState(response.data.cart.length);
             
        });
    }


    sizeHandler=(e)=>{

        this.setState((prev,props)=>
            (
                {size:e.target.value}
        ));

        console.log(e.target.value);
       // this.setState( {price:this.state.size_list[e.target.value].old_price});
       // this.setState( {old_price:this.state.size_list[e.target.value].price});
       // this.setState( {org_price:this.state.size_list[e.target.value].org_price});
       // this.setState( {discount:this.state.size_list[e.target.value].discount});
     
    }

    remarksHandler=(e)=>{


        this.setState((prev,props)=>
            (
                {remarks:e.target.value}
        ));
 
    }
    plusHandler=()=>{

 if(this.state.qty < this.state.product.quantity)
        this.setState((prev,props)=>
            (
                {qty:prev.qty + 1}
        ));
    }

    minusHandler=()=>{
        
        if(this.state.qty > 1)
            this.setState((prev,props)=>
                (
                    {qty:prev.qty - 1}
            ));
    }


    render()
    { 
        const size_content = JSON.parse(localStorage.getItem("content"))[3];
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }

         
    return (
  <div class="ul-inner-page-container">
            <div class="ul-product-details">
                <div class="ul-product-details-top">
                    <div class="row ul-bs-row row-cols-lg-2 row-cols-1 align-items-center">
                        
                        <div class="col">
                               <ProductsSlider image={this.state.product.gallery} title={this.state.product.title}></ProductsSlider>
                        </div>

                        
                        <div class="col">
                            <div class="ul-product-details-txt">
                                 
                                
                                <span class="ul-product-details-price">{this.state.product.price}</span>

                                 
                                <h3 class="ul-product-details-title">{this.state.product.title}</h3>

                                 
                                <p class="ul-product-details-descr">{this.state.product.short_info}</p>

                                 {this.state.sizes.length > 0  && (

                                <div class="ul-product-details-options">
                                    <div class="ul-product-details-option ul-product-details-sizes">
                                        <span class="title">Size</span>

                                        <form action="#" class="variants">
                                             {this.state.sizes.map((item, index) => (
                                            <label for={"ul-product-details-size-1"+item.id}  >
                                                 <input type="radio" value={item.id} onClick={this.sizeHandler} name="product-size" id={"ul-product-details-size-1"+item.id} checked={this.state.size == item.id  ? true : false} hidden />
                                                <span class="size-btn">{item.size}</span>
                                            </label>
                                             ))}
 

                                           
                                        </form>
                                    </div>
 
                                </div>
                                )}

                               
                                <div class="ul-product-details-option ul-product-details-quantity">
                                    <span class="title">Quantity</span>
                                    <form action="#" class="ul-product-quantity-wrapper">
                                        <input type="number" name="product-quantity" id="ul-product-details-quantity" class="ul-product-quantity" value={this.state.qty} min="1" readonly />
                                        <div class="btns">
                                            <button type="button" class="quantityIncreaseButton"  onClick={this.plusHandler}><i class="flaticon-plus"></i></button>
                                            <button type="button" class="quantityDecreaseButton" onClick={this.minusHandler}><i class="flaticon-minus-sign"></i></button>
                                        </div>
                                    </form>
                                </div>

                                 
                                <div class="ul-product-details-actions">
                                    <div class="left">
                                        <button  class={this.state.product.quantity > 0 ? " add-to-cart" : "dnone"}  onClick={this.addToCart}>Add to Cart <span class="icon"><i class="flaticon-cart"></i></span></button>
                                        {/**<button class="add-to-wishlist"><span class="icon"><i class="flaticon-heart"></i></span> Add to wishlist</button>***/}

                                          <label class={this.state.product.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                    </div>
                                        <div className='alert alert-success '  id={this.state.success_cart == 1 ? "success_cart" : "disable_cart"}>Successfully added to cart!</div>
                       
                                     
                                </div>


                               <button className='size-chart-link' onClick={this.openModal}>Size Chart</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ul-product-details-bottom">
                    
                    <div class="ul-product-details-long-descr-wrapper">
                        <h3 class="ul-product-details-inner-title">Item Description</h3>
                        <p><div dangerouslySetInnerHTML={{ __html: this.state.product.description}} /> </p>
                    </div>

                     
                </div>
            </div>

            <Modal show={this.state.showModal} onClose={this.closeModal}> 
               <p><div dangerouslySetInnerHTML={{ __html: size_content.body}} />  </p>
            </Modal>
        </div>
    );
}

}

export default ProductsContent;